import { TextareaAutosize as BaseTextareaAutosize, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React, { useEffect, useId, useState } from 'react';

interface TextareaProps {
  title?: string
  placeholder?: string
  value?: string
  onChange?: (val: string) => void
  required?: boolean
  /** Falls back to the title, then to a generic label. */
  ariaLabel?: string
}


const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const MuiTextarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  width: 320px;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  padding: 8px 12px;
  border-radius: 4px;
  background: '#fff';
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px #F3F6F9;

  &:hover {
    border-color: rgba(0, 0, 0, 0.87);
  }

  &:focus {
    // border-color: #DAE2ED;
    // box-shadow: 0 0 0 1px black;
    // outline-width: 1px;
  }

  // firefox
  &:focus-visible {
    // outline: 0;
  }
`,
);

export const Textarea = ({
  title,
  placeholder,
  value,
  onChange,
  required = false,
  ariaLabel,
}: TextareaProps ) => {
  const [currentValue, setCurrentValue] = useState(value || '')
  const id = useId()

  useEffect(() => {
    setCurrentValue(value || '')
  }, [value])

  return (
    <>
      {title &&
        <Typography
          component="label"
          htmlFor={id}
          variant="subtitle2"
          sx={{ display: 'block', mb: 0.5 }}
        >
          {`${title}${required ? ' *' : ''}`}
        </Typography>
      }
      <MuiTextarea
        style={{ overflow: 'auto' }}
        id={id}
        // Only used when there's no visible label to point at — a label element
        // and an aria-label on the same field would be read out twice.
        aria-label={title ? undefined : (ariaLabel || placeholder || 'Text input')}
        required={required}
        minRows={3}
        sx={{
          minHeight: "120px",
          width: '100%'
        }}
        placeholder={placeholder || 'Edit your copy...'}
        value={currentValue}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          const val = event.currentTarget.value
          if (onChange) onChange(val)
          setCurrentValue(val)
        }}
      />
    </>
  )
}